import React from "react"
import * as styles from "./vertical-spacing-very-small.module.scss"

export default function VerticalSpacingVerySmallRow(props) {
  return  <div className={styles.separator}></div>
}
